import React from "react";
import LogoTecno from "../../tecnologo.png";

export default class Confirm extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            username: ""
        }
    }

    componentDidMount() {
        document.title = this.props.title
    }

    render() {
        return (
            <div>
                <div className="flex flex-col items-center min-h-screen pt-6 sm:justify-center sm:pt-0 bg-gray-50">
                    <div>
                        <h3 className="text-4xl font-bold text-green-600">
                            <img src={LogoTecno} className="mx-auto h-32 w-auto" alt="Logo TecnoRoleplay"/>
                        </h3>
                    </div>

                    <div className="w-full sm:max-w-lg sm:rounded-lg">
                        {this.state.status}
                        <div
                            className="w-full px-16 py-16 mt-6 overflow-hidden bg-white shadow-md">
                            <div>
                                <div>
                                    <h3 className="text-2xl font-bold text-gray-900">
                                        Registrazione completata!
                                    </h3>


                                    <p className="block py-6 font-medium text-gray-600">
                                        La tua registrazione è stata completata con successo!
                                        Ti sono stati inviati per email <b>i codici di backup</b>.
                                    </p>

                                    <p className="block font-medium text-gray-600">
                                        Conservali con estrema cura (per esempio salvali in un luogo sicuro
                                        o scrivili su un foglio di carta) perché saranno l'unico modo
                                        per recuperare il tuo account se ne perderai l'accesso.
                                    </p>

                                    <p className="block py-6 font-medium text-gray-600">
                                        <b>Puoi adesso tornare in gioco e vivere l'esperienza Roleplay realistica!</b>
                                    </p>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

        )
    }
}